export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  imageUrl: string;
  tags: string[];
  isHot: boolean;
  isTop: boolean;
}

export const articles: Article[] = [
  {
    id: "1",
    slug: "danghong-nanyixing-paiyan-shijian",
    title: "独家爆料：某当红男星深夜密会神秘女子，剧组人员集体封口",
    summary: "据知情人士透露，该男星在拍摄新剧期间多次深夜外出，与一位圈外女子关系密切。剧组内部已下达封口令，严禁任何人对外透露消息。本报记者经过长达两个月的追踪调查，独家还原事件全貌。",
    content: `<p>近日，本报接到多位圈内人士爆料，某当红一线男星在横店拍摄新剧期间，屡次深夜单独外出，行踪颇为可疑。</p><p>据知情人士透露，该男星通常在收工后以"需要休息"为由婉拒剧组聚餐，但随后便独自驱车离开酒店，直至凌晨两三点才返回。有工作人员曾在深夜撞见他与一位身材高挑的女子在停车场交谈，两人关系看起来十分亲密。</p><p>"那位女士绝对不是剧组的人，也不是圈内人，"一位不愿透露姓名的工作人员表示，"导演已经明确要求所有人不得对外谈论此事，谁要是乱说就立刻开除。"</p><p>本报记者调查发现，该男星近期确实多次被拍到在深夜现身横店某高端小区，而那正是该神秘女子的住所。据小区物业人员证实，近两个月来频繁看到该男星的保姆车出入。</p><p>更值得注意的是，该男星今年年初刚与相恋多年的女友公开分手，当时对外宣称是"和平分手，各自安好"。如今看来，事情恐怕没有那么简单。</p><p>截至发稿时，该男星的经纪团队尚未对此事做出回应。本报将持续关注事件进展。</p>`,
    categorySlug: "yule",
    categoryName: "娱乐圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-04",
    views: 285600,
    comments: 3421,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20illustration%20dark%20atmospheric%20night%20scene%20with%20silhouette%20of%20a%20male%20celebrity%20walking%20alone%20at%20night%2C%20mysterious%20mood%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20red%20and%20black%20color%20scheme%2C%20editorial%20news%20style&width=800&height=480&seq=article-01&orientation=landscape",
    tags: ["男星", "爆料", "恋情", "娱乐圈"],
    isHot: true,
    isTop: true,
  },
  {
    id: "2",
    slug: "zhiming-zhubo-zhibo-jian",
    title: "知名主播直播间意外翻车，背后资方连夜撤资引发连锁反应",
    summary: "一场突如其来的直播事故，让某平台头部主播陷入舆论漩涡。据悉，该主播在直播中不慎说出不当言论，导致品牌方集体解约，损失高达千万级别。",
    content: `<p>上周五晚间，拥有千万粉丝的某平台头部主播在例行带货直播中，因一句脱口而出的评论引发轩然大波。原本气氛热烈的直播间瞬间沦陷，弹幕从"666"变成了铺天盖地的质疑和批评。</p><p>据现场工作人员回忆，当时该主播正在介绍一款护肤品，在讲解成分时突然岔开话题，说了一句颇具争议的话。虽然助手立刻试图救场，但为时已晚，直播间的录屏已经开始在各大社交平台疯传。</p><p>"直播结束后不到两小时，就有三家品牌方紧急来电要求终止合作，"一位接近该主播团队的消息人士透露，"到第二天下午，全部十二个合作品牌中有九个已经正式发函解约。"</p><p>据业内估算，此次事件给该主播造成的直接经济损失超过800万元，加上后续的违约金和声誉损失，总金额可能超过2000万元。</p><p>更糟糕的是，该主播背后的投资方在事件发生后连夜召开紧急会议，决定撤出后续投资。原本计划在下月启动的线下实体店项目也因此搁浅。</p><p>目前该主播已发布道歉声明，但舆论反应冷淡。一位资深业内人士评价道："直播行业容错率极低，一句话就可能毁掉几年的积累。"</p>`,
    categorySlug: "zhibo",
    categoryName: "直播圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-03",
    views: 452100,
    comments: 6789,
    imageUrl: "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20dramatic%20scene%20with%20bright%20ring%20light%20and%20dark%20background%2C%20streamer%20silhouette%20in%20front%20of%20camera%2C%20chaotic%20atmosphere%2C%20red%20alert%20colors%2C%20digital%20news%20media%20style%2C%20warm%20and%20dark%20contrast%20tonal&width=800&height=480&seq=article-02&orientation=landscape",
    tags: ["直播", "翻车", "主播", "品牌解约"],
    isHot: true,
    isTop: true,
  },
  {
    id: "3",
    slug: "dianying-beihou-ziben-boyi",
    title: "春节档大片幕后资本博弈：三家出品方为分成比例撕破脸",
    summary: "本年度最受期待的春节档大片背后暗流涌动。据悉，三家联合出品方因票房分成比例产生严重分歧，导致宣传物料迟迟未能确定，宣发进度严重滞后。",
    content: `<p>距离春节档还有不到两个月，本年度最受期待的特效大片《龙啸苍穹》的宣传却迟迟未能全面铺开。本报独家获悉，背后的原因并非技术问题，而是三家出品方之间的利益纠纷。</p><p>"问题的根源在于分成比例，"一位接近制片方的消息人士向本报透露，"影片总投资高达5.6亿元，三家出品方各自出资比例不同，但在票房分成上的诉求却相差悬殊。"</p><p>据了解，主出品方A公司出资占比最高，希望按照出资比例分配收益；而另外两家联合出品方则认为自己在宣发渠道和院线资源上的贡献不应被忽视，要求提高分成比例。</p><p>"现在的情况是，哪家都不肯让步，连宣传海报上出品方的排列顺序都成了争论焦点，"该消息人士无奈地表示，"导演夹在中间左右为难，已经两次推迟了预告片的发布日期。"</p><p>业内人士分析指出，这类纠纷在业内并不罕见，但通常会在影片上映前解决。"问题是时间不等人，如果再不达成一致，春节档的黄金排片期可能就要错过了。"</p><p>本报已就此事联系三家出品方的公关部门，截至发稿时均未获得正式回应。</p>`,
    categorySlug: "dianshi",
    categoryName: "影视圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-03",
    views: 198700,
    comments: 2456,
    imageUrl: "https://readdy.ai/api/search-image?query=Film%20studio%20boardroom%20scene%20with%20movie%20posters%20on%20wall%2C%20intense%20business%20negotiation%20atmosphere%2C%20dramatic%20lighting%20with%20shadows%2C%20cinematic%20color%20grading%2C%20Chinese%20film%20industry%20vibe%2C%20warm%20golden%20and%20dark%20tones&width=800&height=480&seq=article-03&orientation=landscape",
    tags: ["电影", "出品方", "分成", "春节档"],
    isHot: true,
    isTop: false,
  },
  {
    id: "4",
    slug: "geshou-xinzhuanji-beiju",
    title: "歌坛天王新专辑疑似抄袭，原创者已委托律师发函",
    summary: "某歌坛天王近日发布的新专辑主打歌被指与一首小众独立音乐作品高度相似，原作曲者已通过社交媒体发声并委托律师处理。粉丝与网友在网上展开激烈争论。",
    content: `<p>歌坛天王周昊天上周五发布的最新专辑主打歌《星光坠落》上线仅三天便在全网获得超过两亿次播放，但这首歌却意外陷入了抄袭争议。</p><p>一位名叫林雨桐的独立音乐人在微博发文称，《星光坠落》的副歌旋律与其2024年发布的单曲《夜空的另一端》几乎一模一样。"我听了第一遍就愣住了，那个旋律是我花了三个月时间反复打磨出来的，我不可能听错。"</p><p>林雨桐还附上了两首歌的旋律对比视频，视频中两首歌的副歌部分确实存在惊人的相似之处。该视频迅速引发热议，相关话题一度冲上热搜榜首。</p><p>"我们已经委托律师向周昊天方面发送了律师函，"林雨桐的经纪人向本报确认，"我们希望通过友好协商解决问题，但如果对方不回应，我们也做好了走法律途径的准备。"</p><p>周昊天的经纪团队在沉默了两天之后发布声明，否认抄袭指控，称《星光坠落》完全由团队原创制作，"如有雷同纯属巧合"。声明还暗示林雨桐是在借此炒作自己。</p><p>音乐版权律师张律师在接受本报采访时表示："根据目前的公开信息，两首歌确实存在实质性相似的可能性。如果进入诉讼程序，法院会委托专业机构进行鉴定。"</p>`,
    categorySlug: "yinyue",
    categoryName: "音乐圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-02",
    views: 523400,
    comments: 8910,
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20dramatic%20moody%20lighting%2C%20musical%20notes%20floating%20in%20air%2C%20headphones%20on%20a%20dark%20desk%2C%20sheet%20music%20scattered%2C%20controversy%20and%20tension%20theme%2C%20dark%20red%20and%20black%20tones%2C%20editorial%20style&width=800&height=480&seq=article-04&orientation=landscape",
    tags: ["歌手", "抄袭", "版权", "新专辑"],
    isHot: true,
    isTop: false,
  },
  {
    id: "5",
    slug: "lanqiu-juxing-zhuandui",
    title: "CBA巨星转会风波：千万年薪背后的豪门恩怨",
    summary: "CBA休赛期最大的转会传闻终于有了新进展。据消息人士透露，某国家队主力球员与现东家的续约谈判已彻底破裂，新东家的报价令人瞠目。",
    content: `<p>CBA休赛期的转会市场从来不缺看点，而今年的重头戏无疑是某国家队主力控卫的去留问题。据本报多方了解，这位全明星球员与现东家的续约谈判已经彻底破裂。</p><p>"谈判破裂的核心原因还是钱，"一位熟悉内情的经纪人透露，"现东家开出的续约条件是年薪800万加奖金，但球员方面认为自己的市场价值远不止这个数。"</p><p>据悉，来自南方的某豪门球队已经向该球员开出了一份令人咋舌的报价：三年总价3600万的巨额合同，外加一套市中心房产的使用权和一辆豪华座驾。</p><p>"这个报价在整个CBA历史上都可以排进前三了，"另一位业内人士评价道，"但问题是，新东家需要先和现东家谈妥转会费。按照该球员目前的合同，违约金高达2000万。"</p><p>现东家方面对此态度强硬，表示"合同在身，想走必须按规矩来"。而球员本人则在社交媒体上发布了一条意味深长的动态："有些路，注定要一个人走。"</p><p>距离新赛季注册截止日还有不到一个月，这场转会大戏的结局如何，整个篮球圈都在翘首以盼。</p>`,
    categorySlug: "tiyu",
    categoryName: "体育圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-02",
    views: 176500,
    comments: 1987,
    imageUrl: "https://readdy.ai/api/search-image?query=Basketball%20court%20at%20night%20with%20dramatic%20spotlight%2C%20single%20basketball%20on%20the%20floor%2C%20empty%20arena%20seats%2C%20transfer%20drama%20theme%2C%20sport%20news%20illustration%2C%20dark%20and%20moody%20atmosphere%2C%20professional%20sports%20photography%20style&width=800&height=480&seq=article-05&orientation=landscape",
    tags: ["CBA", "转会", "篮球", "年薪"],
    isHot: false,
    isTop: false,
  },
  {
    id: "6",
    slug: "guoji-shechipin-neimu",
    title: "国际奢侈品牌大中华区高层内斗，市场总监被曝突然离职",
    summary: "某法国顶级奢侈品牌大中华区近日发生高层人事地震，任职仅八个月的市场总监突然离职，据传与去年某次大型活动的预算超标有关。",
    content: `<p>时尚圈的平静在上周被一条突如其来的消息打破。某法国顶级奢侈品牌大中华区市场总监陈思瑶在任职仅八个月后突然宣布离职，官方声明仅用"个人原因"四个字草草带过。</p><p>但据本报从多个渠道了解，事情远没有那么简单。知情人士透露，陈思瑶的离职与该品牌去年年底在北京举办的一场大型时装秀有关。</p><p>"那场秀的预算原本是800万，但最终花费超过了1500万，"一位曾在品牌任职的员工告诉本报，"超支的主要原因是陈思瑶坚持要邀请一位国际超模压轴，光是那位超模的出场费就高达300万。"</p><p>预算超支的问题在年初的内部审计中被发现，随即引发了法国总部与大中华区管理层之间的激烈争执。据传，大中华区总裁力保陈思瑶，但法国总部坚持要有人为此负责。</p><p>"这件事闹得很大，连巴黎那边都惊动了，"另一位消息人士补充道，"其实陈思瑶的业务能力是很强的，就是太急于证明自己了。"</p><p>目前陈思瑶的去向尚不明确，有传言说她可能加盟某国内新锐设计师品牌。市场部的工作暂时由副总裁直接接管。</p>`,
    categorySlug: "shishang",
    categoryName: "时尚圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-01",
    views: 98700,
    comments: 1234,
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20runway%20backstage%20scene%20with%20luxury%20brand%20elements%2C%20dramatic%20lighting%2C%20high%20fashion%20atmosphere%2C%20mannequins%20and%20designer%20clothing%20racks%2C%20corporate%20drama%20theme%2C%20elegant%20dark%20tones%2C%20editorial%20fashion%20photography%20style&width=800&height=480&seq=article-06&orientation=landscape",
    tags: ["奢侈品", "人事变动", "时尚", "大中华区"],
    isHot: false,
    isTop: false,
  },
  {
    id: "7",
    slug: "shouji-changshang-jiagezhan",
    title: "国产手机巨头价格战内幕：成本价出货只为击垮对手",
    summary: "随着新一代旗舰芯片的发布，国产手机厂商之间的竞争进入白热化阶段。有供应链消息称，某头部品牌以接近成本的价格推出新款旗舰机型，意图抢占市场份额。",
    content: `<p>今年下半年的手机市场注定不会平静。随着新一代旗舰芯片的全面铺货，各大厂商纷纷亮出了自己的底牌。而其中最引人注目的，莫过于某头部品牌以令人难以置信的低价推出了新款旗舰机型。</p><p>"按照我们的估算，这款手机的物料成本大约在3200元左右，加上研发、营销、渠道等费用，总成本至少在3800元以上，"一位供应链分析师告诉本报，"但他们最终的定价只有3499元，这基本上是在赔钱卖。"</p><p>这一激进的定价策略让竞争对手措手不及。据传，另一家厂商在得知该定价后紧急召开了高层会议，讨论是否需要调整自家产品的定价策略。</p><p>"他们的逻辑很简单——先把你挤出市场，然后再慢慢涨价，"一位业内人士分析道，"这种打法在互联网行业很常见，但在利润率本就不高的手机行业，风险非常大。"</p><p>有消息称，这家品牌之所以敢于打价格战，是因为其背后的资本方刚刚完成了一轮巨额融资，弹药充足。而相比之下，二三线品牌的日子就不那么好过了。</p><p>"已经有小品牌在考虑退出手机市场，转做IoT设备了，"一位经销商透露，"这轮洗牌过后，能活下来的可能不超过五家。"</p>`,
    categorySlug: "keji",
    categoryName: "科技圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-31",
    views: 234500,
    comments: 3456,
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20factory%20production%20line%20with%20dramatic%20industrial%20lighting%2C%20circuit%20boards%20and%20phone%20components%2C%20tech%20industry%20competition%20theme%2C%20dark%20and%20modern%20atmosphere%2C%20red%20accent%20lights%2C%20technology%20news%20editorial%20style&width=800&height=480&seq=article-07&orientation=landscape",
    tags: ["手机", "价格战", "供应链", "国产"],
    isHot: false,
    isTop: false,
  },
  {
    id: "8",
    slug: "shejiao-meiti-redian-jiexi",
    title: '社交平台疯传的"保安事件"真相还原：监控视频流出',
    summary: '近日在某社交平台引发数亿阅读的"小区保安与业主冲突"事件迎来反转。本报独家获取的完整监控视频显示，网络传播的版本存在严重剪辑痕迹。',
    content: `<p>过去一周，一段"小区保安辱骂业主"的短视频在各大社交平台疯狂传播，累计播放量突破3亿次。视频中，一名保安似乎正在对一位女业主大声呵斥，引发了网友的强烈愤怒。</p><p>然而，本报记者经过深入调查并获取了事发当天的完整监控录像，发现事情的真相与网络传播的版本截然不同。</p><p>"网上传播的那段视频只截取了冲突的后半部分，"小区物业经理向本报记者展示了完整监控录像，"在此之前，那位业主因为拒不出示门禁卡强行闯入，保安上前劝阻时反遭推搡。保安全程保持了极大的克制。"</p><p>完整监控录像显示，该业主不仅没有携带门禁卡，还对上前询问的保安出言不逊，甚至在保安试图拨打物业电话时抢走了对方的对讲机。网络上传播的那段视频恰恰从保安提高音量开始录制，完全忽略了前因后果。</p><p>"我们也很无奈，"物业经理表示，"事发后我们已经向警方报案，但网上已经铺天盖地都是断章取义的视频了。"</p><p>目前，发布剪辑视频的博主已将视频删除但未做任何解释。不少网友在看到完整真相后纷纷表示被误导，呼吁平台加强对类似内容的审核。</p><p>这起事件再次引发了人们对短视频时代"真相"的思考：你看到的，真的是事情的全部吗？</p>`,
    categorySlug: "wangluo",
    categoryName: "网络热闻",
    author: "51黑料编辑组",
    publishedAt: "2026-08-04",
    views: 876500,
    comments: 12340,
    imageUrl: "https://readdy.ai/api/search-image?query=Security%20camera%20footage%20aesthetic%20with%20grainy%20surveillance%20video%20style%2C%20monitor%20screen%20showing%20residential%20area%2C%20mystery%20and%20truth%20reveal%20theme%2C%20dark%20atmosphere%20with%20green%20night%20vision%20tint%2C%20investigative%20journalism%20style&width=800&height=480&seq=article-08&orientation=landscape",
    tags: ["网络热闻", "反转", "监控", "短视频"],
    isHot: true,
    isTop: true,
  },
  {
    id: "9",
    slug: "nvyanyuan-houqizhi-zhenxiang",
    title: "古装剧女演员后期配音被AI替换，片方被指欺骗观众",
    summary: "某古装大剧近期被眼尖观众发现，女主角的声音与预告片存在明显差异。技术人员分析后确认，正片中的声音为AI合成，而演员本人的原声被完全替换。",
    content: `<p>古装大剧《凤归长安》上周开播以来收视一路飘红，但一个意外的发现让这部剧陷入了争议。有细心观众发现，正片中女主角的声音与开播前发布的预告片存在明显差异。</p><p>"预告片里的声音更自然，有情感起伏；但正片里的声音听起来非常机械，像机器人一样，"一位在豆瓣发帖的观众写道。该帖迅速引发热议，不少观众纷纷回看确认。</p><p>一位不愿透露姓名的音频技术人员在分析后向本报证实，正片中的女主角声音确实为AI合成。"从频谱分析来看，语音的基频变化非常规律，缺乏人类说话时自然的波动，这是典型的TTS特征。"</p><p>据业内人士透露，片方在后期制作阶段与女主角的经纪团队发生了严重分歧。"好像是关于配音费用的争议，具体细节不太清楚，但最后片方决定用AI替代，连配音演员都没请。"</p><p>这种做法在业内引发了巨大争议。资深配音演员李老师表示："用AI替代真人配音，不仅是职业道德的问题，更是对观众的不尊重。观众花钱看剧，有权利听到演员真实的声音。"</p><p>片方在舆论压力下发表声明，承认使用了"人工智能辅助配音技术"，但表示"这并不影响剧集的艺术品质"。显然，这个解释并未让观众满意。</p>`,
    categorySlug: "dianshi",
    categoryName: "影视圈",
    author: "51黑料编辑组",
    publishedAt: "2026-08-01",
    views: 345600,
    comments: 5678,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20set%20with%20actress%20in%20traditional%20hanfu%20dress%2C%20recording%20studio%20microphone%20in%20foreground%2C%20AI%20vs%20human%20voice%20theme%2C%20dramatic%20movie%20set%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic&width=800&height=480&seq=article-09&orientation=landscape",
    tags: ["古装剧", "AI配音", "争议", "影视"],
    isHot: false,
    isTop: false,
  },
  {
    id: "10",
    slug: "wangluo-zhubo-baofu",
    title: "百万粉主播被爆私下辱骂粉丝，录音流出后火速删号跑路",
    summary: "一位在短视频平台拥有超过300万粉丝的美妆主播，近日被爆出在私下聚会中辱骂粉丝的音频。录音曝光后，该主播连夜删除了所有社交账号。",
    content: `<p>短视频时代，网红与粉丝的关系看似亲密，但一段意外流出的音频撕开了这层温情面纱。拥有300多万粉丝的美妆主播"糖糖baby"近日被爆出在私下聚会中嘲讽粉丝的录音。</p><p>在这段长达五分钟的录音中，可以清晰地听到该主播用极其轻蔑的语气评价自己的粉丝："那些人啊，一个月工资还没我一天赚得多，还整天教我怎么化妆，笑死人了。"</p><p>录音还显示，该主播在私下对不同消费能力的粉丝进行了赤裸裸的分级："金主爸爸当然要好好伺候，至于那些白嫖党，爱看不看，我根本不care。"</p><p>录音的流出据称来自该主播的一位前团队成员，此人因薪资纠纷与主播闹翻后选择了曝光。录音的真实性已得到多位业内人士的确认。</p><p>"这个声音我太熟悉了，就是她本人，"一位曾经与该主播合作过的品牌公关向本报确认，"她在圈内的口碑其实一直不太好，只是没想到说话能这么难听。"</p><p>事件发酵后不到六小时，该主播的所有社交账号被清空删除，连带着她在电商平台的店铺也同步关闭。粉丝们从最初的愤怒转为失望，大量粉丝在相关话题下表达心碎。</p>`,
    categorySlug: "zhibo",
    categoryName: "直播圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-30",
    views: 567800,
    comments: 9876,
    imageUrl: "https://readdy.ai/api/search-image?query=Beauty%20live%20streamer%20studio%20with%20makeup%20products%20and%20ring%20light%2C%20dramatic%20mood%20shift%2C%20broken%20mirror%20reflection%2C%20dark%20atmosphere%20contrasting%20with%20glamorous%20setting%2C%20scandal%20exposed%20theme%2C%20vibrant%20red%20and%20dark%20contrast&width=800&height=480&seq=article-10&orientation=landscape",
    tags: ["主播", "辱骂粉丝", "录音", "删号"],
    isHot: false,
    isTop: false,
  },
  {
    id: "11",
    slug: "hezuo-jieyue-zhiming-yiren",
    title: "知名艺人工作室被曝拖欠员工工资，多名核心员工集体离职",
    summary: "某知名艺人个人工作室被内部员工爆料长期拖欠工资和社保，已有超过10名员工在近两个月内离职。艺人本人目前正在国外度假，未作出任何回应。",
    content: `<p>娱乐圈的光鲜亮丽背后，普通工作人员的处境却常常被忽视。近日，某一线艺人个人工作室被多名前员工联合爆料，称存在严重的欠薪问题。</p><p>"从今年三月开始，工资就不再按时发放了，"一位刚离职的前员工告诉本报记者，"一开始是延迟一两周，后来变成延迟一个月，最近两个月更是连一分钱都没见到。"</p><p>更严重的是社保问题。据多名员工反映，该工作室从去年年底开始就不再为员工缴纳社保，但每月的个人扣款部分仍然照常从工资中扣除。"等到我们自己去社保局查才发现，公司已经欠缴半年了。"</p><p>本报了解到，该工作室巅峰时期有超过30名员工，但截至上周，在职人数已不足15人。大部分离职员工均涉及薪酬纠纷，已有部分员工向劳动仲裁部门提起了仲裁申请。</p><p>"艺人本人对工作室的运营基本不管不问，"另一位知情人士透露，"所有的财务和管理都由艺人的母亲负责，但她对现代企业管理几乎一窍不通。"</p><p>目前，该艺人正在国外度假，其社交媒体账号仍在正常更新旅行照片，对工作室的危机似乎毫不在意。本报已通过多种渠道尝试联系其经纪人，但均未得到回应。</p>`,
    categorySlug: "yule",
    categoryName: "娱乐圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-30",
    views: 312400,
    comments: 4567,
    imageUrl: "https://readdy.ai/api/search-image?query=Empty%20office%20with%20desks%20and%20abandoned%20workstations%2C%20dim%20lighting%2C%20unpaid%20bills%20and%20documents%20scattered%2C%20corporate%20crisis%20theme%2C%20entertainment%20industry%20behind%20scenes%2C%20dark%20and%20moody%20atmosphere%2C%20red%20accents&width=800&height=480&seq=article-11&orientation=landscape",
    tags: ["艺人", "欠薪", "工作室", "劳动仲裁"],
    isHot: false,
    isTop: false,
  },
  {
    id: "12",
    slug: "xinyue-tianwang-xingxiang-bengta",
    title: "乐坛天王形象崩塌：被曝15年前比赛黑幕，当年的亚军终于发声",
    summary: "一段尘封15年的选秀比赛内幕近日被亚军选手揭开。当年与某天王同台竞技的歌手首次公开谈及决赛夜的种种异常，暗示比赛结果或有暗箱操作。",
    content: `<p>十五年前那场轰动全国的歌唱选秀总决赛，至今仍被许多观众津津乐道。当年那个青涩的少年在决赛夜一举夺魁，从此开启了华语乐坛的传奇之路。然而，当年获得亚军的选手在最近的直播中首次讲述了决赛背后的故事。</p><p>"决赛前一天晚上，主办方突然通知我换歌，"如今的音乐教师陈明哲在直播中用平静的语气回忆道，"那是一首我完全没有准备过的歌，而冠军要唱的那首歌，他已经排练了整整一个月。"</p><p>陈明哲还透露，决赛当天评委席上出现了两位在彩排时从未出现过的评委，而这两位评委恰好与该选手的经纪公司有着密切的合作关系。</p><p>"其实我心里早就有数了，那场比赛的冠军在比赛开始前就已经内定了，"陈明哲苦笑道，"我当年太年轻，还天真地以为只要自己唱得好就够了。"</p><p>这番爆料在网络上迅速引发热议。一些当年的观众翻出了比赛录像重新审视，发现确实存在诸多疑点。而也有不少该天王的粉丝强烈否认，认为陈明哲是在蹭热度。</p><p>"我不需要蹭任何人的热度，"陈明哲在后续的回应中表示，"我只是觉得，有些事情憋了十五年，是时候说出来了。不是为了改变什么，只是想让真相被看到。"</p>`,
    categorySlug: "yinyue",
    categoryName: "音乐圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-29",
    views: 445600,
    comments: 7654,
    imageUrl: "https://readdy.ai/api/search-image?query=Singing%20competition%20stage%20with%20spotlight%20and%20microphone%2C%20empty%20audience%20seats%2C%20vintage%20style%20with%20modern%20elements%2C%20nostalgia%20and%20truth%20reveal%20theme%2C%20dramatic%20stage%20lighting%2C%20warm%20golden%20and%20dark%20contrast%2C%20music%20industry&width=800&height=480&seq=article-12&orientation=landscape",
    tags: ["选秀", "黑幕", "天王", "比赛"],
    isHot: false,
    isTop: false,
  },
  {
    id: "13",
    slug: "zuqiu-guonei-lianmai-zhenxiang",
    title: "国内足球联赛裁判争议：VAR室录音意外外泄",
    summary: "上周某场焦点战中，VAR裁判与主裁的对话录音意外流出。录音中疑似存在选择性回放的问题，引发球迷对裁判公正性的强烈质疑。",
    content: `<p>足球比赛中的VAR技术本应成为公正的守护者，但上周某场焦点战役后意外流出的一段录音，让人们对这个系统的公正性产生了怀疑。</p><p>在这段据称是VAR裁判室与主裁判通话的录音中，VAR裁判在审查一次关键禁区内身体接触时，反复播放了多个角度。但令人玩味的是，他最终只向主裁判推送了对主队有利的慢镜头回放，而忽略了同样重要的反向角度。</p><p>"你看到了吗？明显碰到了，"VAR裁判在录音中说。但根据现场多个角度的回放，这次接触是否构成犯规本身就存在很大争议。</p><p>录音流出后，受影响的一方俱乐部立即向足协提交了申诉材料。俱乐部在声明中措辞强硬："我们有理由怀疑当值VAR裁判存在主观偏向，这严重影响了比赛的公平性。"</p><p>足协在沉默了两天后发布公告，表示将"认真核查录音的真实性"，并"根据核查结果做出相应处理"。但球迷们对此似乎并不买账，相关话题在社交媒体上的讨论热度持续攀升。</p><p>"如果连VAR都可以被操纵，那足球比赛还有什么公正可言？"一位资深球迷的评论获得了大量点赞。</p>`,
    categorySlug: "tiyu",
    categoryName: "体育圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-28",
    views: 198300,
    comments: 2345,
    imageUrl: "https://readdy.ai/api/search-image?query=Soccer%20VAR%20review%20room%20with%20multiple%20monitors%20and%20screens%2C%20referee%20silhouette%20watching%20replay%2C%20controversy%20and%20suspicion%20theme%2C%20dark%20control%20room%20atmosphere%2C%20green%20field%20on%20screens%2C%20sports%20journalism%20style&width=800&height=480&seq=article-13&orientation=landscape",
    tags: ["足球", "VAR", "裁判", "争议"],
    isHot: false,
    isTop: false,
  },
  {
    id: "14",
    slug: "shechipin-daigou-zousi",
    title: "奢侈品代购灰色链条曝光：从专柜到朋友圈的暴利之路",
    summary: "本报记者历时三个月暗访调查，揭示了一条连接欧洲专柜、代购黄牛和中国消费者的灰色产业链。其中涉及偷税漏税、虚假宣传等多个问题。",
    content: `<p>打开微信朋友圈，几乎每天都能看到奢侈品代购发布的"专柜直采"、"人肉带回"等诱人信息。但这些看似美好的交易背后，隐藏着一条鲜为人知的灰色产业链。</p><p>本报记者经过三个月的暗访调查，深入接触了这条产业链的各个环节。调查发现，从欧洲专柜到中国消费者手中，一个包包的价格可能被加价50%到200%不等。</p><p>"所谓的'专柜直采'很多都是在奥特莱斯或者二手店买的，"一位曾经的代购从业者向记者坦白，"他们会拍一张专柜的照片，然后在折扣店买便宜货，中间的差价全部进了自己的口袋。"</p><p>调查还发现，部分代购通过"拆分包裹"、"低报价格"等方式逃避关税，甚至有人专门组织"人肉代购团"，利用游客身份携带大量奢侈品入境。</p><p>"这是一条分工明确的产业链，"记者在调查报告中写道，"有人负责在欧洲扫货，有人负责物流运输，有人负责国内分销，每个环节都有专业的团队在运作。"</p><p>海关和市场监管部门已经注意到了这一现象。据悉，近期多地海关加大了对代购包裹的查验力度，多个代购团伙被依法查处。</p>`,
    categorySlug: "shishang",
    categoryName: "时尚圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-27",
    views: 154300,
    comments: 2109,
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20shopping%20bags%20and%20branded%20boxes%20stacked%20in%20a%20dim%20warehouse%2C%20gray%20market%20supply%20chain%20theme%2C%20investigative%20journalism%20style%2C%20contrast%20between%20luxury%20and%20darkness%2C%20warm%20golden%20accents%20on%20dark%20background&width=800&height=480&seq=article-14&orientation=landscape",
    tags: ["奢侈品", "代购", "灰色产业", "海关"],
    isHot: false,
    isTop: false,
  },
  {
    id: "15",
    slug: "rengongzhineng-qiye-neidou",
    title: "AI独角兽企业创始人内斗升级：联合创始人被保安拦在公司门外",
    summary: "国内某估值超过百亿的AI独角兽企业内部矛盾全面爆发。联合创始人兼CTO上周返回公司时被保安拦在门外，引发了一场关于公司控制权的公开争夺战。",
    content: `<p>科技圈的创业故事从来不缺戏剧性，但上周发生在某AI独角兽企业的一幕还是让不少业内人士大跌眼镜。该公司联合创始人兼CTO在出差归来后，竟然被保安拦在了公司大门外。</p><p>"当时场面非常尴尬，"一位目击者向本报描述道，"CTO拿着工卡准备刷门禁，但系统显示权限已失效。保安说接到了行政部的通知，不允许他进入办公区域。"</p><p>据知情人士透露，这起事件的导火索是CTO与CEO在公司发展战略上的根本性分歧。CTO主张继续加大研发投入，深耕核心技术；而CEO则认为公司应该尽快商业化，加速IPO进程。</p><p>"两个人的矛盾已经持续了大半年了，"一位前员工告诉记者，"董事会基本上站在CEO这边，因为投资人都希望尽快看到回报。但CTO手里还持有近20%的股权，不是那么容易就被踢出局的。"</p><p>事件发生后，CTO在社交媒体上发布了一封公开信，称自己"被非法剥夺了参与公司经营的权利"，并表示将"采取一切必要的法律手段维护自身权益"。</p><p>这起内斗已经引起了投资圈的广泛关注。有分析人士指出，如果双方无法在短期内达成和解，公司的下一轮融资将面临重大不确定性。</p>`,
    categorySlug: "keji",
    categoryName: "科技圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-26",
    views: 189700,
    comments: 2876,
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20tech%20office%20building%20entrance%20at%20night%2C%20security%20guard%20standing%20at%20gate%2C%20dramatic%20corporate%20power%20struggle%20theme%2C%20glass%20building%20reflecting%20city%20lights%2C%20dark%20and%20tense%20atmosphere%2C%20red%20and%20blue%20contrast%20lighting&width=800&height=480&seq=article-15&orientation=landscape",
    tags: ["AI", "创业", "内斗", "独角兽"],
    isHot: false,
    isTop: false,
  },
  {
    id: "16",
    slug: "wangmin-weiquan-jiti",
    title: "知名电商平台大数据杀熟被实锤，网友晒图维权引发集体诉讼",
    summary: "一场由网友自发组织的大数据杀熟检测行动，揭露了某电商平台对不同用户显示不同价格的事实。同款商品价格差异最高达30%，目前已有多名用户联合提起集体诉讼。",
    content: `<p>"我一直觉得自己买的东西比别人贵，直到今天我才确认了这个事实。"网友"小小消费者"在社交平台晒出了两张截图——同一款手机，她的账号显示价格为6999元，而她丈夫的账号显示价格仅为5499元。</p><p>这条帖子迅速引发了广泛关注。越来越多的网友开始晒出类似的对比截图，涉及的商品从电子产品到日用品，几乎无所不包。经统计，同一商品在不同账号间的价格差异从5%到30%不等。</p><p>"大数据杀熟已经不是秘密了，但这么明目张胆还是第一次见，"一位互联网分析师表示，"平台会根据你的消费习惯、设备型号、甚至地理位置来动态定价。简单来说，系统认为你越有钱、越离不开这个平台，开价就越高。"</p><p>面对铺天盖地的质疑，涉事平台在沉默两天后发布了一份语焉不详的声明，将价格差异归因于"会员等级优惠"和"限时促销活动"的不同。但这个解释显然无法令人信服。</p><p>"如果是会员优惠，那我老公的普通账号为什么比我的高级会员账号还便宜？"一位网友的追问引发大量共鸣。</p><p>目前，已有超过500名用户联合委托律师事务所提起集体诉讼。律所方面表示，已收集了大量证据，预计下周将正式向法院递交起诉材料。</p>`,
    categorySlug: "wangluo",
    categoryName: "网络热闻",
    author: "51黑料编辑组",
    publishedAt: "2026-07-25",
    views: 654300,
    comments: 9876,
    imageUrl: "https://readdy.ai/api/search-image?query=Ecommerce%20shopping%20cart%20on%20laptop%20screen%20with%20different%20price%20tags%2C%20big%20data%20price%20discrimination%20theme%2C%20consumer%20rights%20protection%2C%20digital%20commerce%20illustration%2C%20red%20warning%20signals%20on%20dark%20tech%20background&width=800&height=480&seq=article-16&orientation=landscape",
    tags: ["电商", "大数据杀熟", "维权", "集体诉讼"],
    isHot: false,
    isTop: false,
  },
  {
    id: "17",
    slug: "zongyi-jiemu-beihou-gushi",
    title: "热门综艺导演被爆私下收取选手好处费，选角存在暗箱操作",
    summary: "某热门选秀综艺的前工作人员近日曝光节目内幕，称导演组私下收取选手贿赂，金额从数万到数十万不等，直接影响了选手的晋级和镜头分配。",
    content: `<p>选秀综艺向来是年轻人追逐梦想的舞台，但一位前工作人员的最新爆料揭示了这个舞台背后不为人知的一面。据其透露，某热门选秀综艺的导演组成员长期私下收取选手的好处费。</p><p>"这不是什么秘密，圈内人都知道，"这位化名为"阿杰"的前工作人员在匿名采访中表示，"收费标准和能得到的回报都是明码标价的。五万块保你进前五十，十万块保你进前三十，要是出得起二十万以上，基本能走到决赛。"</p><p>阿杰还透露，好处费不仅仅是影响晋级排名。"花了钱的选手，镜头明显比别人多。一集节目里他们的戏份可能占一半，而没花钱的选手可能连一个特写镜头都没有。"</p><p>节目组方面在得知爆料后迅速发布声明，坚决否认存在任何"暗箱操作"行为，并称爆料者是"因被辞退而怀恨在心的前员工"。但声明并未能平息公众的质疑。</p><p>"如果真的是清白的，为什么不敢公开所有选手的评分表？"一位网友的评论获得了大量点赞。</p><p>据悉，相关监管部门已经注意到了网络上的讨论，或将对此事展开调查。</p>`,
    categorySlug: "dianshi",
    categoryName: "影视圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-24",
    views: 412300,
    comments: 6543,
    imageUrl: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20behind%20the%20scenes%2C%20dark%20backstage%20area%20with%20spotlights%20peeking%20through%2C%20money%20envelope%20being%20passed%2C%20corruption%20in%20entertainment%20theme%2C%20dramatic%20shadow%20play%2C%20warm%20stage%20light%20contrasting%20dark%20backstage&width=800&height=480&seq=article-17&orientation=landscape",
    tags: ["综艺", "选秀", "贿赂", "导演"],
    isHot: false,
    isTop: false,
  },
  {
    id: "18",
    slug: "duanju-xingye-luanxiang",
    title: "短剧行业乱象：演员被拖欠片酬成常态，制作方跑路事件频发",
    summary: "短剧行业火爆背后暗藏危机。多位短剧演员向本报反映被拖欠片酬的问题，有的甚至被拖欠半年之久。与此同时，多家短剧制作公司传出资金链断裂消息。",
    content: `<p>近年来，短剧以惊人的速度崛起，成为内容产业最炙手可热的赛道之一。但在火爆的表象之下，从业者的真实处境却令人揪心。</p><p>"我这个月拍了四部短剧，到现在一分钱的片酬都没收到，"演员小雨（化名）无奈地告诉记者，"最早的那部是三个月前拍的，制作方一开始说'下个月结'，然后就是无止境的拖延。"</p><p>小雨的遭遇并非个例。本报采访了超过二十位短剧演员，其中超过七成反映遇到过不同程度的片酬拖欠问题。最严重的一位被拖欠了超过半年的片酬，总额超过十万元。</p><p>"短剧行业的问题是发展太快，监管跟不上，"一位行业分析师指出，"很多制作公司就是几个人的小团队，今天注册公司明天拍短剧，后天可能就跑路了。演员根本没有有效的维权途径。"</p><p>据本报了解，仅上个月就有至少三家短剧制作公司传出资金链断裂或负责人失联的消息，涉及的未结片酬总额超过百万元。</p><p>"我真的很喜欢演戏，但这个行业太让人寒心了，"小雨在采访的最后说道，"如果情况再不改善，我只能考虑转行了。"</p>`,
    categorySlug: "dianshi",
    categoryName: "影视圈",
    author: "51黑料编辑组",
    publishedAt: "2026-07-23",
    views: 187600,
    comments: 2109,
    imageUrl: "https://readdy.ai/api/search-image?query=Short%20drama%20film%20set%20with%20camera%20equipment%20and%20lights%2C%20actors%20waiting%20in%20dim%20lighting%2C%20unpaid%20and%20struggling%20industry%20theme%2C%20documentary%20style%2C%20contrast%20between%20bright%20set%20and%20dark%20mood%2C%20Chinese%20entertainment&width=800&height=480&seq=article-18&orientation=landscape",
    tags: ["短剧", "片酬", "拖欠", "行业乱象"],
    isHot: false,
    isTop: false,
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.categorySlug === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}

export function getHotArticles(limit: number = 6): Article[] {
  return articles.filter(a => a.isHot).slice(0, limit);
}

export function getTopArticles(limit: number = 3): Article[] {
  return articles.filter(a => a.isTop).slice(0, limit);
}

export function getLatestArticles(limit: number = 12): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
}

export function getRelatedArticles(article: Article, limit: number = 4): Article[] {
  return articles.filter(a => a.categorySlug === article.categorySlug && a.id !== article.id).slice(0, limit);
}